import { graphql } from '@tn/foundation/graphql/__generated/gql';

export const updateOptInCacheKey = 'updateOptIn';

export const updateOptInMutation = graphql(/* GraphQL */ `
    mutation UpdateOptIn($optIn: Boolean!) {
        updateOptIn(optIn: $optIn) {
            success
        }
    }
`);
